import { MediaLoadingIndicator, MediaPlayButton } from "media-chrome/react";
import { memo } from "react";
import PauseIcon from "../assets/pause.svg";
import PlayIcon from "../assets/play.svg";
import styles from "../index.module.css";

interface CenteredChromeProps {
  playButtonStyle: { container: string; icon: string };
  enableHoverPlay: boolean;
  showPlayButton: boolean;
}

export const CenteredChrome = memo(
  ({
    playButtonStyle,
    enableHoverPlay,
    showPlayButton,
  }: CenteredChromeProps) => (
    <div
      slot="centered-chrome"
      className={
        playButtonStyle.container
          ? playButtonStyle.container
          : "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60px] h-[60px] play-button"
      }
    >
      {!enableHoverPlay && showPlayButton && (
        <MediaPlayButton className="bg-transparent absolute inset-0 z-10 overflow-hidden">
          <div className={styles.playButton} slot="play">
            <PlayIcon
              className={
                playButtonStyle.icon ? playButtonStyle.icon : "w-9 h-9"
              }
            />
          </div>
          <div className={styles.playButton} slot="pause">
            <PauseIcon
              className={
                playButtonStyle.icon ? playButtonStyle.icon : "w-9 h-9"
              }
            />
          </div>
        </MediaPlayButton>
      )}
      <div className="absolute inset-0 flex items-center justify-center">
        <MediaLoadingIndicator></MediaLoadingIndicator>
      </div>
    </div>
  )
);

CenteredChrome.displayName = "CenteredChrome";
